module.exports = __webpack_public_path__ + "static/img/yellow-power-slug_256.cbeb695.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow-power-slug_256.png
// module id = QH/S
// module chunks = 0